import React, {useEffect} from 'react';
import classes from './ThanksPage.module.scss';
import {Helmet} from "react-helmet";
import {HomeBreadcrumb} from "../../components/UI/HomeButton";
import ReactGa from "react-ga";
import {FormattedMessage} from "react-intl";

const ThanksPage = (props) => {
    // const [state, setState] = useState({done: false, list_data: []});

    useEffect(() => {
        /*=======
            console.log('useEffect 1');
        * =======*/
        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        window.scrollTo(0, 0);
    }, [props.location.pathname]);

    return (
        <>
            <Helmet>
                <meta name="description" content={'JAPFA FOOD: The all in one solution for your F&B needs. We provides a variety of animal proteins:  chicken, wagyu beef, fish, dairy, processed meat, sauces and seasonings. We offers custom support tailored to the needs of our food service partners.'}/>
                <meta name="keywords" content={"frozen food, meat shop, Chicken shop, supplier frozen food, food service, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, food solutions, JBFS, Food Supplier"}/>
                <meta name="author" content=""/>
                <meta property="og:title" content={'Thank you for contacting Japfa Food'}/>
                <meta property="og:description" content={'JAPFA FOOD: The all in one solution for your F&B needs. We provides a variety of animal proteins:  chicken, wagyu beef, fish, dairy, processed meat, sauces and seasonings. We offers custom support tailored to the needs of our food service partners.'}/>
                <title>{'Thank you for contacting Japfa Food'}</title>
                <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
            </Helmet>

            <section className={[classes.ThanksPage_sectionBread].join(' ')}>
                <div className={["jbfs-wrapper", classes.ThanksPage_wrapperBread].join(' ')}>
                    <div className={["jbfs-breadcrumb-row",].join(' ')}>
                        <HomeBreadcrumb/>
                        <span>/</span>
                        <div><FormattedMessage id={"thankspage.breadcrumb"} defaultMessage={"Thank you for contacting us"}/></div>
                    </div>
                </div>
            </section>
            {/*Bread crumbs region*/}

            <section className={classes.ThanksPage_sectionContent}>
                <div className={["jbfs-wrapper", classes.ThanksPage_wrapperContent].join(' ')}>
                    <div className={classes.Icon_bgImage}/>
                    <div className={classes.Copyright_right}>
                        <h2><FormattedMessage id={"thankspage.title"} defaultMessage={"Awesome!"}/> </h2>
                        <h3><FormattedMessage id={"thankspage.thanks"} defaultMessage={"Thank you for contacting Japfa Food"}/></h3>
                        <span><FormattedMessage id={"thankspage.message"} defaultMessage={"We have received your message and would like to thank you for writing to us. If your inquiry is urgent, please use the telephone number listed below to talk to one of our staff members. Otherwise, we will reply by email as soon as possible."}/></span>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ThanksPage